import React from 'react';
import { useMaybeRoomContext } from '@livekit/components-react';
import { mergeProps, randomId } from '../../helpers/utilities';
import { RoomEvent } from 'livekit-client';
import { useMediaDeviceSelect } from '@livekit/components-react';
import { useFullScreenMountNode } from '../../contexts/FullScreenContext';
import { Menu, IconButton, IconArrowOpenDownLine } from '@instructure/ui';
export const MediaDeviceSelect = React.forwardRef(function MediaDeviceSelect(
  {
    kind,
    initialSelection,
    onActiveDeviceChange,
    onDeviceListChange,
    onDeviceSelectError,
    exactMatch,
    track,
    requestPermissions,
    onError,
    ...props
  },
  ref
) {
  const room = useMaybeRoomContext();
  const mountNode = useFullScreenMountNode();

  const handleError = React.useCallback(
    (e) => {
      if (room) {
        // Emit the error from outside of the room context
        room.emit(RoomEvent.MediaDevicesError, e);
      }
      if (onError) {
        onError(e);
      }
    },
    [room, onError]
  );

  const { devices, activeDeviceId, setActiveMediaDevice, className } =
    useMediaDeviceSelect({
      kind,
      room,
      track,
      requestPermissions,
      onError: handleError,
    });

  React.useEffect(() => {
    if (initialSelection !== undefined) {
      setActiveMediaDevice(initialSelection);
    }
  }, [setActiveMediaDevice, initialSelection]);

  React.useEffect(() => {
    if (typeof onDeviceListChange === 'function') {
      onDeviceListChange(devices);
    }
  }, [onDeviceListChange, devices]);

  React.useEffect(() => {
    if (activeDeviceId && activeDeviceId !== '') {
      if (onActiveDeviceChange) {
        onActiveDeviceChange(activeDeviceId);
      }
    }
  }, [activeDeviceId, onActiveDeviceChange]);

  const handleActiveDeviceChange = async (deviceId) => {
    try {
      await setActiveMediaDevice(deviceId, { exact: exactMatch });
    } catch (e) {
      if (e instanceof Error) {
        if (onDeviceSelectError) {
          onDeviceSelectError(e);
        }
      } else {
        throw e;
      }
    }
  };

  const mergedProps = React.useMemo(
    () => mergeProps(props, { className }, { className: 'lk-list' }),
    [className, props]
  );

  const isActive = (deviceId, activeId, index) => {
    return deviceId === activeId || (index === 0 && activeId === 'default');
  };

  const renderItems = () => {
    const items = [];

    devices.map((device, index) => {
      let label = device.label;

      if (isActive(device.deviceId, activeDeviceId, index)) {
        // TODO: IF we want to show the active device...
        //label = label + ' (active)';
      }

      if (index > 0) {
        items.push(<Menu.Separator key={`item_${randomId()}`} />);
      }
      items.push(
        <Menu.Item
          key={`item_${randomId()}`}
          onSelect={() => handleActiveDeviceChange(device.deviceId)}
          selected={true}
        >
          {label}
        </Menu.Item>
      );
    });
    return items;
  };

  return (
    <Menu
      key={`device_${randomId()}`}
      placement="bottom"
      shouldContainFocus
      shouldReturnFocus
      mountNode={() => mountNode} // Ensures the menu overlays everything
      trigger={
        <IconButton
          withBackground={false}
          withBorder={false}
          color="primary"
          size="small"
          screenReaderLabel="Update source"
          margin="none"
          padding="none"
        >
          <IconArrowOpenDownLine />
        </IconButton>
      }
    >
      {renderItems()}
    </Menu>
  );
});
